import { twMerge } from 'tailwind-merge'
import audio from '@assets/file-types/audio.svg'
import c from '@assets/file-types/c.svg'
import cpp from '@assets/file-types/cpp.svg'
import csharp from '@assets/file-types/csharp.svg'
import css from '@assets/file-types/css.svg'
import database from '@assets/file-types/database.svg'
import text from '@assets/file-types/document.svg'
import email from '@assets/file-types/email.svg'
import file from '@assets/file-types/file.svg'
import folder from '@assets/file-types/folder.svg'
import font from '@assets/file-types/font.svg'
import go from '@assets/file-types/go.svg'
import h from '@assets/file-types/h.svg'
import html from '@assets/file-types/html.svg'
import image from '@assets/file-types/image.svg'
import java from '@assets/file-types/java.svg'
import javascript from '@assets/file-types/javascript.svg'
import json from '@assets/file-types/json.svg'
import kotlin from '@assets/file-types/kotlin.svg'
import log from '@assets/file-types/log.svg'
import markdown from '@assets/file-types/markdown.svg'
import pdf from '@assets/file-types/pdf.svg'
import php from '@assets/file-types/php.svg'
import powerpoint from '@assets/file-types/powerpoint.svg'
import python from '@assets/file-types/python.svg'
import react from '@assets/file-types/react.svg'
import reactTs from '@assets/file-types/react_ts.svg'
import ruby from '@assets/file-types/ruby.svg'
import rust from '@assets/file-types/rust.svg'
import sass from '@assets/file-types/sass.svg'
import shell from '@assets/file-types/console.svg'
import swift from '@assets/file-types/swift.svg'
import table from '@assets/file-types/table.svg'
import typescript from '@assets/file-types/typescript.svg'
import video from '@assets/file-types/video.svg'
import word from '@assets/file-types/word.svg'
import xml from '@assets/file-types/xml.svg'
import yaml from '@assets/file-types/yaml.svg'
import archive from '@assets/file-types/zip.svg'

// Icons from Material Icon Theme 5.40.0 (MIT, see assets/file-types/LICENSE). Anything not listed gets `file`.
const ICONS_BY_EXTENSION = new Map(
  (
    [
      [pdf, ['pdf']],
      [word, ['doc', 'docx', 'odt', 'rtf', 'pages']],
      [table, ['xls', 'xlsx', 'ods', 'numbers', 'csv', 'tsv']],
      [powerpoint, ['ppt', 'pptx', 'odp', 'key']],
      [text, ['txt']],
      [markdown, ['md', 'mdx']],
      [image, ['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'svg', 'bmp', 'tif', 'tiff', 'ico']],
      [video, ['mp4', 'mov', 'm4v', 'webm', 'mkv', 'avi']],
      [audio, ['mp3', 'wav', 'm4a', 'aac', 'flac', 'ogg']],
      [archive, ['zip', 'tar', 'gz', 'tgz', 'rar', '7z', 'bz2', 'xz']],
      [email, ['eml']],
      [log, ['log']],
      [font, ['ttf', 'otf', 'woff', 'woff2']],
      [database, ['sql', 'db', 'sqlite']],
      [json, ['json', 'jsonl']],
      [yaml, ['yml', 'yaml']],
      [xml, ['xml']],
      [html, ['html', 'htm']],
      [css, ['css']],
      [sass, ['scss', 'sass']],
      [javascript, ['js', 'mjs', 'cjs']],
      [react, ['jsx']],
      [typescript, ['ts', 'mts', 'cts']],
      [reactTs, ['tsx']],
      [python, ['py', 'ipynb']],
      [shell, ['sh', 'bash', 'zsh']],
      [go, ['go']],
      [rust, ['rs']],
      [java, ['java']],
      [kotlin, ['kt', 'kts']],
      [swift, ['swift']],
      [ruby, ['rb']],
      [php, ['php']],
      [c, ['c']],
      [h, ['h']],
      [cpp, ['cpp', 'cc', 'cxx', 'hpp']],
      [csharp, ['cs']],
    ] as const
  ).flatMap(([icon, extensions]) => extensions.map((extension) => [extension, icon] as const)),
)

/** The icon for a file's type, read from its extension, or a folder. */
export function FileTypeIcon({
  name,
  isDirectory = false,
  className,
}: {
  name: string
  isDirectory?: boolean
  className?: string
}) {
  const extension = name.split('.').pop()?.toLowerCase() ?? ''
  const src = isDirectory ? folder : (ICONS_BY_EXTENSION.get(extension) ?? file)
  return <img src={src} alt="" draggable={false} className={twMerge('size-4 shrink-0', className)} />
}
